module.exports = __webpack_public_path__ + "b3aec27ef1d1250be2e9b1c2cc466565.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-16.png
// module id = 2143
// module chunks = 0